import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {AthleteEventsChartResponseApiModel} from "../athlete-events-chart-response.api-model";
import {AthleteEventsChartDataSource} from "../athlete-events-chart.data-source";
import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {CompetitionFactory} from "../../common/competition/domain-services/competition-factory";
import {PartialGameFactory} from "../../partial-game/services/partial-game.factory";
import {PartialGameApiModel} from "../../partial-game/models/partial-game-api-model";
import {CountryDomainModel} from "../../common/country/models/country-domain-model";
import {SportDomainModel} from "../../sports/models/sport-domain-model";
import {PartialGameDomainModel} from "../../partial-game/models/partial-game-domain-model";
import {CountryFactory} from "../../common/country/domain-services/country-factory";
import {SportsFactory} from "../../sports/domain-services/sports.factory";
import {AthleteChartEventsDomainModel} from "../../full-game/models/chart-events/athlete-chart-events/athlete-chart-events.domain-model";
import {MemberFactory} from "../../yard/member/member-factory";
import {MemberDomainModel} from "../../yard/member/member-domain-model";
import {AthleteDomainModel} from "../../common/athlete/athlete-domain-model";
import {AthletesFactory} from "../../athletes/services/athletes.factory";
import {AthleteChartEventsApiModel} from "../../full-game/models/chart-events/athlete-chart-events/athlete-chart-events.api-model";

export class AthleteEventsChartFactory extends BaseFactory {

  static injectables = [...BaseFactory.injectables, CompetitionFactory, PartialGameFactory, CountryFactory, SportsFactory, MemberFactory, AthletesFactory];

  constructor(loggerUtils: LoggerUtils, termsUtils: TermsUtils, competitionFactory: CompetitionFactory, partialGameFactory: PartialGameFactory, countryFactory: CountryFactory, sportFactory: SportsFactory, memberFactory: MemberFactory, athletesFactory: AthletesFactory) {
    super(loggerUtils, termsUtils);
    this.competitionFactory = competitionFactory;
    this.countryFactory = countryFactory;
    this.sportFactory = sportFactory;
    this.partialGameFactory = partialGameFactory;
    this.memberFactory = memberFactory;
    this.athletesFactory = athletesFactory;
  }

  createResponse(apiModel: AthleteEventsChartResponseApiModel) {
    const responseApiModel: AthleteEventsChartResponseApiModel = new AthleteEventsChartResponseApiModel(apiModel);

    return responseApiModel;
  }

  createDomainModel(response: AthleteEventsChartResponseApiModel): AthleteEventsChartDataSource {
    if (!response) {
      return null;
    }
    const countriesMap: Map<Number, CountryDomainModel> = this.countryFactory.createDomainMap(response.countries, CountryDomainModel);
    const sportsMap: Map<Number, SportDomainModel> = this.sportFactory.createDomainMap(response.sports, SportDomainModel);
    const competitions: Map<Number, CompetitionDomainModel> = this.competitionFactory.createDomainMap(response.competitions, CompetitionDomainModel, 'id', response.sports, response.countries);
    const athletesMap: Map<Number, AthleteDomainModel> = response.athletes && this.athletesFactory.createDomainMap(response.athletes, AthleteDomainModel, 'id', response.sports, response.countries);
    const gamesMap: Map<Number, PartialGameDomainModel> = this.partialGameFactory.createDomainMap(response.games, PartialGameApiModel, 'id', competitions, sportsMap, countriesMap);
    const sportDomainModel: SportDomainModel = response.sports.first();
    const membersMap: Map<Number, MemberDomainModel> = this.memberFactory.createDomainMap(response.members, MemberDomainModel, 'id', sportDomainModel)

    const chartEventsModels: Array<AthleteChartEventsDomainModel> = response.chartEvents?.length > 0 ? response.chartEvents.map((chartEvent: AthleteChartEventsApiModel) => {
      const athlete: AthleteDomainModel = athletesMap?.get(chartEvent.athleteId);
      return new AthleteChartEventsDomainModel(chartEvent, membersMap, gamesMap, athlete)
    }) : null;

    return new AthleteEventsChartDataSource(response, chartEventsModels);
  }
}
